(ns hai.home.desktop.mini-apps.tasks
  "My Tasks mini-app card: the same task data as the full Tasks page, grouped
   into collapsible Now / Next / Later sections. The header's looking glass
   opens the universal bar; the ＋ swaps the card into Add-a-task mode, and
   the lane it opens at is named beside it, on the pill that sets it
   ([[hai.tasks.add-pill]]); a row swaps it for the task open in it. The title
   links to the full Tasks page. Everything shown comes from
   [[hai.tasks.mini-app]]; this card brings the frame, the sizes and the
   routing."
  (:require
   [hai.entity.data :as entity-data]
   [hai.mini-apps.data :as mini-apps-data]
   [hai.mini-apps.frame :as mini-apps]
   [hai.spaces.data :as spaces-data]
   [hai.tasks.add-pill :as add-pill]
   [hai.tasks.card :as task-card]
   [hai.tasks.data :as data]
   [hai.tasks.form :as form]
   [hai.tasks.header :as header]
   [hai.tasks.mini-app :as tasks-mini-app]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.web-app.routing :as routing]
   [hai.web-app.universal-bar :as universal-bar]
   [lambdaisland.ornament :as o]
   [reagent.core :as r]))

;; The body under the header is one height in every mode — the list, Add a
;; task, a task open in the card, even empty or loading — so switching between
;; them doesn't move the dashboard: a short list leaves room below it, and a
;; long list or form scrolls inside rather than stretching the card.
(o/defstyled card tasks-mini-app/card
  [mini-apps/list-clip {:height "440px"}])

;; Links the add/save toasts to the task. Home lists tasks rather than showing
;; one, so the link always has somewhere to go.
(def ^:private task-link
  {:href-fn #(routing/href :tasks/detail {:task/uuid %})
   :target routing/link-target})

(defn- section-view [{:keys [label tasks open? on-toggle]}]
  [mini-apps/section-view
   {:label label :item-count (count tasks) :open? open? :on-toggle on-toggle}
   (when (seq tasks)
     (into [:div.section-tasks]
           (map (fn [task]
                  ^{:key (:task/uuid task)}
                  [task-card/task-row-component task
                   {:on-open-entity entity-data/open-entity}]))
           tasks))])

(defn panel [{title :mini-app/title}]
  (r/with-let [!open (r/atom data/bucket-ids)
               toggle-section (fn [id]
                                (swap! !open (fn [open]
                                               (if (contains? open id)
                                                 (disj open id)
                                                 (conj open id)))))]
    (let [buckets @(<s [::data/buckets])
          loaded? @(<s [::data/loaded?])
          adding? @(<s [::data/composer-open?])
          editing-task @(<s [::data/editor-task])
          default-urgency @(<s [::data/default-urgency])
          collapsed? @(<s [::mini-apps-data/collapsed? :tasks])
          open @!open
          total (reduce + (map count (vals buckets)))]
      (cond
        adding?
        [card
         [tasks-mini-app/composer-view
          {:draft-id data/composer-draft-id
           :saving? (= :start @(<s [:fetch/state ::create]))
           :show-hint? true
           :on-save (fn [staged]
                      (>e [::data/create (assoc staged
                                                :request-id ::create
                                                :task-link task-link
                                                :success-fx [[:dispatch [::data/close-composer]]])])
                      (swap! !open conj (data/staged-bucket staged)))
           :on-close #(>e [::data/close-composer])}]]

        editing-task
        [card
         [tasks-mini-app/editing-view
          {:task editing-task
           :show-hint? true
           :spaces? @(<s [::spaces-data/enabled?])
           :on-open-entity entity-data/open-entity
           :task-link task-link}]]

        :else
        [card {:class (when collapsed? "collapsed")}
         [header/bar
          {:title title
           :href (routing/href :tasks/view)
           :target routing/link-target}
          [:button.bar-action-btn
           {:type "button"
            :aria-label "Search tasks"
            :title "Search tasks"
            :on-click #(>e [::universal-bar/open])}
           [icons/outlined-search {:size 18}]]
          [add-pill/component
           {:on-add (fn []
                      (>e [::mini-apps-data/expand :tasks])
                      (>e [::data/open-composer (form/from-task nil default-urgency)]))}]
          [mini-apps/collapse-toggle
           {:collapsed? collapsed?
            :label      "tasks"
            :class      "bar-action-btn"
            :on-toggle  #(>e [::mini-apps-data/toggle-collapsed :tasks])}]]
         (when-not collapsed?
           [mini-apps/list-clip
            (cond
              (not loaded?) nil
              (zero? total) [:div.app-placeholder "Nothing yet — add your first task above."]
              :else
              (into [tasks-mini-app/sections]
                    (map (fn [{:keys [id label]}]
                           ^{:key id}
                           [section-view {:label label
                                          :tasks (get buckets id)
                                          :open? (contains? open id)
                                          :on-toggle #(toggle-section id)}]))
                    data/bucket-tabs))])]))))
